export class VerificationSearch {
  constructor(
    public instanceKey?: string,
    public volunteerIds?: number[],
    public portalId?: number,
    public status?: string,
    public limit?: number,
    public pageNumber?: number,
    public pageSize?: number
  ) {}
}
